// packages/ui-kit/src/primitives/Textarea.tsx
// C3F v18 — reference: design/system/components/forms/Textarea.{jsx,prompt.md}
import { type TextareaHTMLAttributes, forwardRef } from "react";

interface Props extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: boolean;
}

export const Textarea = forwardRef<HTMLTextAreaElement, Props>(function Textarea(
  { error = false, className = "", rows = 4, ...rest },
  ref,
) {
  // Fields use --border-control (WCAG 1.4.11); hover never darkens the border.
  const borderCls = error
    ? "border-danger-strong"
    : "border-border-control focus-visible:border-border-focus";
  return (
    <textarea
      ref={ref}
      rows={rows}
      className={`block w-full resize-y rounded-md border bg-elevated px-3.5 py-3 font-sans text-base leading-[1.55] text-fg-default outline-none transition-[border-color,box-shadow] duration-fast placeholder:text-fg-muted focus-visible:shadow-focus disabled:cursor-not-allowed disabled:opacity-45 sm:text-sm ${borderCls} ${className}`}
      {...rest}
    />
  );
});
